<div class="full-height flex-column">
  <app-custom-settings-dialog-header [entityTranslationKey]="TOOL_TRANSLATION_KEY" [menuItems]="[generalTab]" (cancel)="navigateBack()" (save)="save()" />
  <form class="p-48 b-neutral-950 flex-grow" [formGroup]="settingsForm">
    <app-name-generation-pattern-new class="half-width" [nameGeneratorFormControl]="settingsForm.controls.nameGenerator" [nameGenerationProperties]="nameGenerationProperties" />
  </form>
</div>
